import React from 'react';
import FooterStyled from './Footer.styled';

const Footer = () => (
    <FooterStyled>
    </FooterStyled>
);


export default Footer;


// WEBPACK FOOTER //
// ./src/components/molecules/Footer/Footer.js